




















































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { AuditsOption } from '~/models/audit/options'
import AuditsShopEntry from '~/components/shared/classified/audits/AuditsShopEntry.vue'
import { AuditPackage } from '~/models/audit/package'
import { useI18n } from '~/compositions/i18n'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { ciVerifiedBadge } from '~/icons/source/solid/verified-badge'
import { ciMakeCarcheck } from '~/icons/source/regular/make-carcheck'
import useStatic from '~/compositions/static'
import { ciMakeBikecheck } from '~/icons/source/regular/make-bikecheck'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'

export default defineComponent({
  components: { AuditsShopEntry, CPrice },
  props: {
    shops: { type: Array as PropType<AuditsOption[]>, required: true }
  },
  setup(props) {
    const { shops } = toRefs(props)
    const showMore = ref([])
    const { t } = useI18n()
    const s = useStatic()

    const { getters } = useNamespacedStore(CLASSIFIED_VIEW_NS)
    const forBikes = computed<boolean>(() => getters('isBikeClassified'))

    const providersLogos = {
      5562383: s('/nuxt-static/img/audits/logos/spotmechanic.png'),
      1000024380: s('/nuxt-static/img/audits/logos/carcheck.png'),
      1000223313: s('/nuxt-static/img/audits/logos/autoduder.png'),
      1000407345: s('/nuxt-static/img/audits/logos/check-your-car.png'),
      1000449073: s('/nuxt-static/img/audits/logos/fourtounas.png'),
      1000322237: s('/nuxt-static/img/audits/logos/we-check-your-car.png'),
      1000397330: s('/nuxt-static/img/audits/logos/imperial-dekra.svg'),
      1000400987: s('/nuxt-static/img/audits/logos/vitas.png'),
      1000539780: s('/nuxt-static/img/audits/logos/autosafe.png'),
      1000566501: s('/nuxt-static/img/audits/logos/check-my-car.png'),
      1000553263: s('/nuxt-static/img/audits/logos/eurokteo.png'),
      1000565249: s('/nuxt-static/img/audits/logos/starenios.png'),
      1000492044: s('/nuxt-static/img/audits/logos/hk.png'),
      1000728259: s('/nuxt-static/img/audits/logos/doumanidis.jpg')
    }

    const shopsGroups = computed(() => {
      if (!shops.value?.length) {
        return null
      }

      const groups = shops.value.reduce(
        (result: { [key: string]: any }, current) => {
          ;(result[current.shop.auditProviderId] =
            result[current.shop.auditProviderId] || []).push(current)
          return result
        },
        {}
      )

      // Sorting each provider shop based on distance
      for (const key in groups) {
        groups[key].sort(
          (a: AuditsOption, b: AuditsOption) => a.distance - b.distance
        )
      }

      return groups
    })

    const filteredShops = computed(() => {
      const fShops: { [key: string]: any } = {}
      shopsGroupsKeys.value.forEach(key => {
        if (showMore.value.includes(key)) {
          fShops[key] = shopsGroups.value?.[key]?.slice()
        } else {
          fShops[key] = shopsGroups.value?.[key]?.slice(0, 2)
        }
      })
      return fShops
    })

    const shopsGroupsKeys = computed(() => {
      const groupKeys = Object.keys(shopsGroups.value || {})
      return groupKeys.sort((a, b) => {
        const aMinDistance = shopsGroups.value?.[a][0].distance
        const bMinDistance = shopsGroups.value?.[b][0].distance
        return aMinDistance - bMinDistance
      })
    })

    const prices = computed(() => {
      const priceData = {}
      Object.keys(filteredShops.value || {}).flatMap(key => {
        const shops = shopsGroups.value?.[key]
        const pricesArray = shops.flatMap((s: AuditsOption) =>
          s.packages.map((p: AuditPackage) => p.price)
        )
        const min = Math.min.apply(Math, pricesArray)
        priceData[key] = {
          price: `${min}€`,
          priceLabel:
            min === Math.max.apply(Math, pricesArray)
              ? t('price')
              : `${t('price')} ${t('from')
                  .toString()
                  .toLocaleLowerCase()}`
        }
      })
      return priceData
    })

    function handleShowMoreProviders(k: string) {
      if (showMore.value.includes(k)) {
        showMore.value = showMore.value.filter((key: string) => key !== k)
      } else {
        showMore.value.push(k)
      }
    }

    const placeholderIcon = computed(() => {
      return forBikes.value ? ciMakeBikecheck : ciMakeCarcheck
    })

    return {
      filteredShops,
      providersLogos,
      shopsGroupsKeys,
      prices,
      ciVerifiedBadge,
      shopsGroups,
      handleShowMoreProviders,
      showMore,
      placeholderIcon
    }
  }
})
